import { Navigate, Outlet, useLocation } from "react-router-dom"
import { useAuthStore } from "@/stores/auth"
import { isSuperAdmin } from "@/constants/user-types"
import { ADMIN_HOME } from "@/constants/paths/admin"

/**
 * GuestGuard - Only allows unauthenticated users
 * Redirects authenticated users based on role:
 * - Super admins → /admin
 * - Others → redirect path or /
 */
export function GuestGuard() {
  const location = useLocation()
  const token = useAuthStore((state) => state.token)
  const user = useAuthStore((state) => state.user)

  // If authenticated, redirect based on role
  if (token) {
    // Super admins always go to admin portal
    if (isSuperAdmin(user)) {
      return <Navigate to={ADMIN_HOME} replace />
    }
    const from = (location.state as { redirect?: string })?.redirect || "/"
    return <Navigate to={from} replace />
  }

  return <Outlet />
}

export default GuestGuard
